import { useState, useEffect } from "react";
import Modal from "../ui/Modal";
import Input from "../ui/Input";
import Select from "../ui/Select";
import Button from "../ui/Button";
import { toISO, today } from "../../lib/dateUtils";

const PAYMENT_METHODS = ["Wire", "Cash", "Instapay", "Card", "Other"];

export default function DividendForm({ open, onClose, onSubmit, initial, departments }) {
  const [form, setForm] = useState(() => initial || {
    date: toISO(today()),
    department: "",
    recipient: "Ahmed",
    amount: "",
    paymentMethod: "Wire",
    notes: "",
  });
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (open) {
      setForm(initial || {
        date: toISO(today()),
        department: "",
        recipient: "Ahmed",
        amount: "",
        paymentMethod: "Wire",
        notes: "",
      });
      setErrors({});
    }
  }, [open, initial]);

  const update = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const handleSubmit = (e) => {
    e.preventDefault();
    const errs = {};
    if (!form.date) errs.date = "Required";
    if (!form.department) errs.department = "Pick a department";
    if (!form.recipient?.trim()) errs.recipient = "Required";
    if (!(Number(form.amount) > 0)) errs.amount = "Must be > 0";
    if (Object.keys(errs).length) { setErrors(errs); return; }

    onSubmit({
      ...form,
      amount: Number(form.amount) || 0,
      recipient: form.recipient.trim(),
    });
    onClose();
  };

  return (
    <Modal open={open} onClose={onClose} title={initial?.id ? "Edit dividend" : "Log dividend"}>
      <form onSubmit={handleSubmit} className="space-y-3">
        <div className="grid grid-cols-2 gap-3">
          <Input
            label="Date *"
            type="date"
            value={form.date}
            onChange={(e) => update("date", e.target.value)}
            error={errors.date}
          />
          <Input
            label="Amount (USD) *"
            type="number"
            step="0.01"
            value={form.amount}
            onChange={(e) => update("amount", e.target.value)}
            error={errors.amount}
            placeholder="2000.00"
          />
        </div>

        <Select
          label="Department *"
          value={form.department}
          onChange={(e) => update("department", e.target.value)}
          error={errors.department}
        >
          <option value="">— Select department —</option>
          {(departments || []).map((d) => (
            <option key={d} value={d}>{d}</option>
          ))}
        </Select>

        <Input
          label="Recipient *"
          value={form.recipient}
          onChange={(e) => update("recipient", e.target.value)}
          error={errors.recipient}
          placeholder="Ahmed"
        />

        <Select
          label="Payment method"
          value={form.paymentMethod}
          onChange={(e) => update("paymentMethod", e.target.value)}
        >
          {PAYMENT_METHODS.map((m) => (
            <option key={m} value={m}>{m}</option>
          ))}
        </Select>

        <Input
          label="Notes"
          value={form.notes}
          onChange={(e) => update("notes", e.target.value)}
          placeholder="(optional)"
        />

        <div className="flex justify-end gap-2 pt-2">
          <Button variant="secondary" type="button" onClick={onClose}>Cancel</Button>
          <Button type="submit">{initial?.id ? "Save changes" : "Log dividend"}</Button>
        </div>
      </form>
    </Modal>
  );
}
